// Согласована ли текущая версия: у документа есть approval и оно на последней
// версии (добавление версии сбрасывает согласование — это read-инвариант бэка).
export function isCurrentApproved(doc: {
  approval?: { version_number: number } | undefined
  current_version: { number: number }
}): boolean {
  return doc.approval != null && doc.approval.version_number === doc.current_version.number
}
